import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";

@inheritSerialization(BaseUUIDEntity)
export default class AsesmenPendaftar extends BaseUUIDEntity {

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public pendidikan: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

    @serialize
    @deserialize
    public alamat_lengkap: string = "";

    @serialize
    @deserialize
    public jenis_kelamin: string = "";

    @serialize
    @deserialize
    public sekolah_asal: string = "";

}